import { jsx } from 'react/jsx-runtime';

const SvgZapierLogo = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("rect", { width: 20, height: 20, x: 2, y: 2, fill: "#2D2E2E", rx: 3 }) }));

export { SvgZapierLogo as default };
//# sourceMappingURL=ZapierLogo.es.js.map
